import type React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface UsageDetailItemProps {
    icon: IconDefinition;
    children: React.ReactNode;
}

export function UsageDetailItem({ icon, children }: UsageDetailItemProps): React.ReactElement {
    return (
        <div className="flex items-start gap-2 text-xs leading-tight">
            <span className="inline-flex text-gray-600">
                <FontAwesomeIcon icon={icon} aria-hidden />
            </span>
            <div className="flex flex-col gap-1 [&_span]:text-gray-500 [&_strong]:text-gray-800">
                {children}
            </div>
        </div>
    );
}
